export const LOAD_ACRONYMS = 'LOAD_ACRONYMS'
